
import bawUtil from '../../util/baw'

const baw = {
  state: {
    LoginToken: '',
    BtnAuth:''
  },

  mutations: {
    SET_Token: (state, token) => {
      bawUtil.addToken(token)
      state.LoginToken = token
    },
    DEL_Token: (state) => {
      bawUtil.delToken()
      state.LoginToken = ''
    },
    
    SET_Auth: (state, auth) => {
      bawUtil.addBtnAuth(auth)
      state.BtnAuth = auth
    },
    DEL_Auth: (state) => {
      bawUtil.delBtnAuth()
      state.BtnAuth = ''
    }
  },

  actions:{
    SETBawToken({commit}, token){
      commit('SET_Token', token)
    },
    DELBawToken({commit}){
      commit('DEL_Token')
    }
    ,
    SETBawAuth({commit}, auth){
      commit('SET_Auth', auth)
    },
    DELBawAuth({commit}){
      commit('DEL_Auth')
    }
  }
}

export default baw



// WEBPACK FOOTER //
// ./src/store/modules/baw.js